import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'
import { FormWrapper, FormSubmit } from '@myxplor/forms'

const ReportSuccess = ({ resetCurrentReport, name }) => (
  <FormWrapper
    onSubmit={resetCurrentReport}
    render={() => (
      <Fragment>
        <Heading small>Your {name} has been generated</Heading>
        <fieldset>
          The report will soon download to your computer.
          It is a CSV file that can be opened in a spreadsheet program (such as Excel or Google Sheets)
        </fieldset>
        <FormSubmit>
          Done
        </FormSubmit>
      </Fragment>
    )}
  />
)

export default ReportSuccess


// WEBPACK FOOTER //
// ./src/reports/views/success.jsx